<template>
    <div>
        <div class="fw-gwitems">
            <div class="fw-gwitems-f">
                          <span class="fw-cats" :class="{'active':index==tabIndex}" v-for="(cat,index) in list"
                                @click="getItems(index,cat)">
                               {{cat.catName}}
                          </span>
            </div>
            <div class="fw-gwitems-r">
                <div class="fwgr-item" v-for="item in items">
                    <div class="fwgr-item-info">
                        <span class="mc">{{item.composeName}}</span>
                        <span class="jg">¥{{item.tcPrice}}</span>
                    </div>
                    <el-button size="mini" @click="toChoose(item)">选择</el-button>
                </div>
            </div>
        </div>
        <van-popup v-model="show" position="bottom" closeable lock-scroll overlay>
            <div style="padding: 15px;border-bottom: #EEEEEE solid 1px">
                <div class="fwgr-item-info">
                    <span class="mc">{{item.composeName}}</span>
                    <span class="jg">¥{{zj}}</span>
                    <div class="tiaozheng">
                        <span class="xiadanjiage">购买次数</span>
                        <van-stepper v-model="buy" min="0" @change="setBuyNum" />
                    </div>
                    <div class="tiaozheng">
                        <span class="xiadanjiage">赠送次数</span>
                        <van-stepper v-model="give" min="0" @change="setGiveNum" />
                    </div>
                    <div class="tiaozheng">
                        <span class="xiadanjiage">套餐价</span>
                        <el-input v-model="tcj" size="mini" placeholder="请输入价格" class="ki"></el-input>
                    </div>
                    <div class="tiaozheng">
                        <span class="xiadanjiage">有效期</span>
                        <el-input v-model="days" size="mini" placeholder="请输入价格" class="ki"></el-input>
                    </div>
                </div>
            </div>
            <div class="fw-gw-emps">
                <div class="emp-gw" v-if="fEmps.length>0">
                    <span class="gw">{{fName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp"  v-for=" (emp,index) in fEmps">
                            <span class="empname" :class="{hui: emp.check}" @click="setEmp(emp,1)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="sEmps.length>0">
                    <span class="gw">{{sName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp"  v-for=" emp in sEmps">
                            <span class="empname" :class="{hui: emp.check}"  @click="setEmp(emp,2)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="tEmps.length>0">
                    <span class="gw">{{tName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp"  v-for=" emp in tEmps">
                            <span class="empname" :class="{hui: emp.check}" @click="setEmp(emp,3)">{{emp.nickName}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="adddatabtn" @click="addData"> 确定</div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',
                tabIndex: 0,
                tcType:2,
                list:[],
                items:[],


                show: false,
                item: {},
                fEmps: [],
                sEmps: [],
                tEmps: [],
                fName: '',
                sName: '',
                tName: '',

                total:0,
                zj:0,
                buyjg:0,
                givejg:0,
                tcj:0,
                buy:0,
                give:0,
                days:0,
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.getCatItems()
        },
        methods: {
            async getCatItems() {
                let data = {
                    deptId: this.deptId,
                    tcType: this.tcType,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwComposes", data)
                if (res.catComposes&&res.catComposes.length > 0) {
                    this.list = res.catComposes
                    this.items = res.catComposes[0].composes
                }
            },
            getItems(index, cat) {
                this.tabIndex = index
                this.items = cat.composes
            },
            toChoose(item) {
                this.chushi()
                this.show = true
                let newItem = JSON.parse(JSON.stringify(item))
                newItem.total = newItem.tcPrice
                this.item = newItem
                this.getFwEmps()
            },

            async getFwEmps() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmps", data)
                this.fEmps = res.fEmps;
                this.sEmps = res.sEmps;
                this.tEmps = res.tEmps;
                this.fName = res.fName;
                this.sName = res.sName;
                this.tName = res.tName;
            },

            addData() {
                if (this.buy==0){
                    this.$notify({type: 'danger', message: '请输入购买次数'});
                    return;
                }
                let emps = []
                if (this.fEmps.length > 0) {
                    this.fEmps.forEach(item => {
                        if (item.check) {
                            emps.push({
                                empId: item.id,
                                empName: item.nickName,
                                station: 1,
                                gradeId: item.gradeId,
                            })
                        }
                    })
                }
                if (this.sEmps.length > 0) {
                    this.sEmps.forEach(item => {
                        if (item.check) {
                            emps.push({
                                empId: item.id,
                                empName: item.nickName,
                                station: 2,
                                gradeId: item.gradeId,
                            })
                        }
                    })
                }
                if (this.tEmps.length > 0) {
                    this.tEmps.forEach(item => {
                        if (item.check) {
                            emps.push({
                                empId: item.id,
                                empName: item.nickName,
                                station: 3,
                                gradeId: item.gradeId,
                            })
                        }
                    })
                }
                let quantity =parseInt(this.buy)+parseInt(this.give)
                let composeItems = [
                    {
                        itemName: this.item.composeName,
                        quantity: quantity,
                    }
                ]
                let newItem ={
                    commodityId: this.item.id,
                    categoryId: '',
                    commodityName: this.item.composeName,
                    price: this.tcj,
                    oglPrice: this.tcj,
                    cost: this.item.cost,
                    cmnVal: this.item.cmnVal,
                    composeItems: composeItems,
                    tcType: this.item.tcType,
                    quantity: quantity,
                    days: this.days,
                    giveNum: this.give,
                    miType: 3,
                    emps:emps,
                };
                var total = parseFloat(this.total) + parseFloat(this.tcj)
                this.total = total.toFixed(1)
                let data ={
                    item:newItem,
                    total:this.tcj
                }
                this.$emit('toTcbChoose',data)
                this.show = false
            },
            setBuyNum(val){
                let tzj = parseFloat(this.item.tcPrice) * parseFloat(val)
                this.buyjg=tzj.toFixed(2)
                this.zj = parseFloat(this.buyjg)+parseFloat(this.givejg)
            },
            setGiveNum(val){
                let tzj = parseFloat(this.item.tcPrice) * parseFloat(val)
                this.givejg=tzj.toFixed(2)
                this.zj = parseFloat(this.buyjg)+parseFloat(this.givejg)
            },
            //设置员工
             setEmp(item) {
              item.check = !item.check
            },

            // 将选中的人状态更改为没选中
            setUnchecked() {
                this.changeEmpFalse(this.emps);
            },

            //更改状态
            changeEmpTrue(emps, emp, check) {
                emps.forEach(item => {
                    if (emp.empId == item.id) {
                        item.check = check
                    }
                })
            },

            //更改状态
            changeEmpFalse(emps) {
                emps.forEach(item => {
                    item.check = false
                })
            },
            //计算价格
            calculationPrice(num1, num2) {
                var num = parseFloat(num1 * num2 / 10)
                return num.toFixed(1);
            },
            chushi(){
                this.total=0
                this.zj=0
                this.buyjg=0
                this.givejg=0
                this.tcj=0
                this.buy=0
                this.give=0
                this.days=0
            },
        },
    };
</script>

<style lang="scss" scoped>
    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff;
        border-radius: 0px;
        border-bottom-color: #EEEEEE;
    }
</style>
